import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { getPeriods, getRunway, queryKeys } from '@/api/fpa'

import { usePeriodSelection } from './usePeriod'

/** The runway for the URL's quarter and budget (`?q=`, `?budget=`; legacy `?asOf=`). */
export function useRunwayQuery() {
  const selection = usePeriodSelection()
  return useQuery({
    queryKey: queryKeys.runway(selection),
    queryFn: ({ signal }) => getRunway(selection, signal),
    // Keep showing the previous quarter while the next one loads (no full-page skeleton flash).
    placeholderData: keepPreviousData,
  })
}

/** Quarters with data (`GET /v1/periods`). */
export function usePeriodsQuery() {
  return useQuery({
    queryKey: queryKeys.periods,
    queryFn: ({ signal }) => getPeriods(signal),
    staleTime: 5 * 60_000,
  })
}
